<div class="flex flex-col self-stretch gap-2.5">
  <h1 class="template-headline">New Template</h1>
  <p class="template-subtext">
    Welcome to your central Template Management dashboard, the ultimate hub for designing and refining modular certificate elements. <br>
    Here, you can effortlessly navigate your entire library to access and update existing template at a moment's notice. <br>
    If you're looking to start fresh, simply select the "New Template" button to launch a blank workspace. <br>
    Once active, the editor gives you total creative freedom to integrate and customize placeholders exactly to your liking. <br>
    This intuitive system ensures you maintain complete control over both your archived assets and your brand-new creations.
  </p>
  <span class="w-fit"
        [pTooltip]="permissionService.hasRedactRights() ? 'Create a new template' : 'Insufficient permissions'"
  >
    <button pButton
            type="button"
            data-test="template-new-button"
            severity="primary"
            [disabled]="!permissionService.hasRedactRights()"
            (click)="router.navigate(['/template/create'])"
    >
      New Template
    </button>
  </span>
</div>
